export type Day = "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday";
export const DAYS: Day[] = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];

export type LogStatus = "submitted" | "approved" | "rejected" | "pending";

export const WEEKS: number[] = Array.from({ length: 52 }, (_, i) => i + 1);

export const entriesKey = (email: string, week: number) =>
  `student_entries_${email}_week_${week}`;

// supervision keys
export const supervisionStatusKey = (email: string) =>
  `student_supervision_status_${email}`;
export const supervisorEmailKey = (studentEmail: string) =>
  `student_supervisor_email_${studentEmail}`;
export const supervisorNameKey = (email: string) =>
  `student_supervisor_name_${email}`;

export const STUDENT_REQUEST_EMAIL_KEY = "student_request_email";

export const statusToClasses = (status: LogStatus): string => {
  switch (status) {
    case "submitted":
      return "bg-green-100 text-green-700";
    case "approved":
      return "bg-blue-100 text-blue-700";
    case "rejected":
      return "bg-red-100 text-red-700";
    case "pending":
    default:
      return "bg-yellow-100 text-yellow-700";
  }
};
export const DAY_TO_NUM: Record<Day, number> = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
};
export const NUM_TO_DAY: Record<number, Day> = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
};
export function safeDate(dateLike?: string | null) {
  if (!dateLike) return "—";
  return String(dateLike).slice(0, 10);
}
export function fullNameFromSupervisor(sup: any) {
  if (!sup) return "—";
  const parts = [sup.title, sup.firstname, sup.othernames, sup.surname].filter(
    Boolean
  );
  return parts.join(" ");
}

export const computeStatus = (
  lb: any
): "none" | "pending" | "approved" | "rejected" => {
  const st = String(lb?.status || "").toLowerCase();

  // Your sample: status "submitted" but supervisor exists
  if (lb?.supervisor) return "approved";
  if (st === "pending" || st === "submitted") return "pending";
  if (st === "rejected") return "rejected";
  return "none";
};
